module.exports = __webpack_public_path__ + "static/media/tire-tread-depth-method.a77882f5.svg";